export default {
    // 原生的错误类型
    400: '服务器错误',
    401: '认证失败',
    404: '服务器错误',
    500: '服务器错误',
    501: '服务器错误',
    502: '服务器错误',
    503: '服务器错误',
    // 自定义的错误类型
    1000: '未知错误',
    // 1001为业务逻辑错误，提示内容为后端返回的对应message
    1001: '数据错误'
}